import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import POContainer from "../components/ListsOverview/POContainer";
import { UrlContext } from "../contexts/UrlContext";

export default function ListsOverview() {
  useEffect(() => {
    document.title = "Lists Overview";
  }, []);

  // const [notificationList, setNotificationList] = useState([]);
  const { API_URL } = useContext(UrlContext);
  // useEffect(() => {
  //   const ephToken = localStorage.getItem("eph-token");
  //   const token = JSON.parse(ephToken).value;

  //   fetch(`${API_URL}notification-list`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "x-access-token": token,
  //     },
  //     body: JSON.stringify(),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setNotificationList(data.notifications);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  const navigate = useNavigate();
  const [refreshAfterFilter, setRefreshAfterFilter] = useState(false);
  const [count, setCount] = useState(1);

  useEffect(() => {
    if (refreshAfterFilter) {
      setCount(count + 1);
      setRefreshAfterFilter(false);
    }
  }, [refreshAfterFilter]);

  return (
    <POContainer
      key={count}
      refreshAfterFilter={refreshAfterFilter}
      setRefreshAfterFilter={setRefreshAfterFilter}
    />
  );
}
